/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AddStory from '../Common/addStory';
import Feature from '../Features/feature';
import Result from '../WorkPackage/result';

const ChildrenTab = ({
  id,
  capabilityChildren,
  disabled,
  createTemporaryStory,
  updateTemporaryStory,
  featureOrganizationLevel,
  capability,
  showDeleted
}) => (
  <div>
    <div className="story-header">
      <div className="col-sm-12 feature-add-story">
        <AddStory
          label="FEATURE"
          disabled={disabled}
          featureId={id}
          parentId={id}
          level={2}
          result={capability}
          createTemporaryStory={createTemporaryStory}
          isNewWorkPackage={id <= 0}
          organizationLevel={featureOrganizationLevel}
          placement="result capability"
        />
      </div>
    </div>
    <div className="story-body">
      <div className="uncategorized">
        {capabilityChildren.map((result) => {
          if (!result.deleted_at || (showDeleted && result.deleted_at))
            return (
              <div
                key={result.id ? result.id : result.temporaryId}
                className="feature-story"
              >
                {result.level > 1 ? (
                  <Feature
                    item={result}
                    updateTemporaryStory={updateTemporaryStory}
                    noHolon
                  />
                ) : (
                  <Result
                    result={result}
                    updateTemporaryStory={updateTemporaryStory}
                    isNewFeature={false}
                    noHolon
                    childCard
                  />
                )}
              </div>
            );
        })}
      </div>
    </div>
  </div>
);

ChildrenTab.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.number,
  capabilityChildren: PropTypes.array,
  capability: PropTypes.object.isRequired
};

ChildrenTab.defaultProps = {
  disabled: true,
  id: 0,
  capabilityChildren: []
};

const mapStateToProps = (state) => ({
  showDeleted: state.trashReducer.showTrash
});

export default connect(mapStateToProps)(ChildrenTab);
